import { render } from "./Com_Loading.vue?vue&type=template&id=4eff1efc&scoped=true"
import script from "./Com_Loading.vue?vue&type=script&lang=js"
export * from "./Com_Loading.vue?vue&type=script&lang=js"

import "./Com_Loading.vue?vue&type=style&index=0&id=4eff1efc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eff1efc"]])

export default __exports__